import { pipe } from 'fp-ts/lib/function';
import {
  createAuthorizedPostRequest,
  decode,
  fetchApi,
} from '@/services/api';
import { chain } from 'fp-ts/TaskEither';
import { prismaticJwtTokenCodec } from '@/services/api/resources/prismatic-jwt-token/codec';

const baseUrl = '/v2/integrations/jwt';
export const create = () => pipe(
  baseUrl,
  createAuthorizedPostRequest,
  chain(fetchApi),
  chain(decode(prismaticJwtTokenCodec)),
);
